import { createApp } from 'vue'
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue-next";
import store from "./store/store.js";
import router from "./router";
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { db } from "./firebase/firebaseInit";
// import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "./assets/css/navbar.scss";
import "./assets/css/talkii.css";
import "./assets/css/main.css";
import "./assets/css/platform.scss";
import "./assets/css/footer.css";
import "./assets/css/switch.scss";
import "./assets/css/dialog.css";

const app = createApp(App);
app.use(BootstrapVue);
app.use(store);
app.use(router);
// app.use(axios);
const auth = getAuth();
onAuthStateChanged(auth, (user) => {
  // TODO: not sure if this wors
  if (!user) {
    router.replace("/login");
  }
  db;
});
app.mount("#app");

// getAuth().onAuthStateChanged(() => {
//   db;
//   // if (!app) {
//   new Vue({
//     store,
//     router,
//     render: (h) => h(App),
//   }).$mount("#app");
//   // }
// });
